import { ModuleItemType } from "@packages/flow-core/module";
import { request } from "../request";

import { StreamResponseDataType } from "../utils/streamFetch";

export enum ShowWelcomeWordEnum {
  No, // 不展示
  Yes, // 展示
}

/** 素材库文件的类型 */
export enum MaterialTypeEnum {
  /** 图片 */
  Image = 1,
  /** 文件 */
  File = 2,
  /** 视频 */
  Video = 3,
  /** 音频 */
  Audio = 4,
}

export const MaterialTypeOptions = [
  {
    label: "图片",
    value: MaterialTypeEnum.Image,
  },
  {
    label: "文件",
    value: MaterialTypeEnum.File,
  },
  {
    label: "视频",
    value: MaterialTypeEnum.Video,
  },
  {
    label: "音频",
    value: MaterialTypeEnum.Audio,
  },
];

export interface ITemplateMaterialConfig {
  name: string;
  type: MaterialTypeEnum;
  description?: string;
}

export interface ITemplateBasicInfo {
  id?: string;
  templateGroupId?: string; // 模板组 id
  name: string;
  description: string;
  videoUrl: string; // 视频地址
  showWelcomeWord: ShowWelcomeWordEnum;
}

export interface IBasicTemplateFlow extends ITemplateBasicInfo {
  materialConfigs: ITemplateMaterialConfig[];
  sort: number;
  personalFeePerMonth: number;
  personalFeePerYear: number;
  organizationFeePerMonth: number;
  organizationFeePerYear: number;
}

export interface ITemplateFlow extends IBasicTemplateFlow {
  modules: ModuleItemType[]; // 模块
  version: number;
}
/**
 * 保存模板
 * @param data
 * @returns
 */
export function saveTemplateFlowService(data: Partial<ITemplateFlow>) {
  return request<API.BaseResponse<void>>(
    "/api/insnail-flow-platform/damselfish/flowTemplate/management/save",
    {
      method: "POST",
      data,
    }
  );
}

/**
 * 运行模板调试
 * @param templateId
 * @param data
 * @returns
 */
export function runTemplateFlowAppService(
  templateId: number | string,
  data: Record<string, any>
) {
  return request(
    `/api/insnail-flow-platform/damselfish/flowTemplate/runtime/test/${templateId}`,
    {
      method: "POST",
      data,
      responseType: "stream",
    }
  );
}

/**
 * 获取模板数据
 * @param templateId
 * @returns
 */
export function getTemplateFlowService(templateId: string | number) {
  return request<API.BaseResponse<ITemplateFlow>>(
    `/api/insnail-flow-platform/damselfish/flowTemplate/management/${templateId}`
  );
}

/** 查询欢迎语 */
export function queryWelcomeWordsService(flowId: string, chatId: string) {
  return request<API.BaseResponse<StreamResponseDataType[]>>(
    `/api/insnail-flow-platform/flow/runtime/test/chat/${flowId}/welcome`,
    {
      params: { chatId },
    }
  );
}

export function clearTemplateHistoryService(chatId: string) {
  return request<API.BaseResponse>(
    `/api/insnail-flow-platform/damselfish/flowTemplate/runtime/test/clear-chat/${chatId}`,
    {
      method: "PUT",
    }
  );
}

export type McpServerData = {
  id?: string;
  name: string;
  description: string;
  address: string;
  params: string;
};
type McpServerListParams = {
  current: number;
  size: number;
  name?: string;
  ids?: string[];
};
export function getMcpServerListService(params: McpServerListParams) {
  return request<API.BaseListResponse<McpServerData>>(
    "/api/damselfish-ai-model-hub/MCPServer/list",
    {
      method: "POST",
      data: params,
    }
  );
}
